import type { ProvideConfigurationMessage } from '../types';

export const configurationData: ProvideConfigurationMessage = {
  requestId: 'to-be-automatically-replaced',
  currentPerformanceId: 68,
  isTouch: true,
  performances: [
    {
      date: 1767142800,
      id: 68,
      label: 'Kiosk Movie Admission',
      prices: [
        {
          priceTypeId: 1,
          price: '100.0000',
          zoneId: 23
        },
        {
          priceTypeId: 1,
          price: '90.0000',
          zoneId: 24
        },
        {
          priceTypeId: 1,
          price: '80.0000',
          zoneId: 25
        },
        {
          priceTypeId: 1,
          price: '70.0000',
          zoneId: 26
        },
        {
          priceTypeId: 2,
          price: '180.0000',
          zoneId: 23
        },
        {
          priceTypeId: 2,
          price: '160.0000',
          zoneId: 24
        },
        {
          priceTypeId: 2,
          price: '140.0000',
          zoneId: 25
        },
        {
          priceTypeId: 2,
          price: '120.0000',
          zoneId: 26
        }
      ],
      zoneMapId: 4
    },
    {
      date: 1767229200,
      id: 69,
      label: 'Kiosk Movie Admission',
      prices: [
        {
          priceTypeId: 1,
          price: '100.0000',
          zoneId: 33656
        },
        {
          priceTypeId: 1,
          price: '90.0000',
          zoneId: 33657
        },
        {
          priceTypeId: 1,
          price: '80.0000',
          zoneId: 33678
        },
        {
          priceTypeId: 1,
          price: '70.0000',
          zoneId: 33659
        },
        {
          priceTypeId: 1,
          price: '60.0000',
          zoneId: 33660
        },
        {
          priceTypeId: 1,
          price: '50.0000',
          zoneId: 33661
        },
        {
          priceTypeId: 2,
          price: '200.0000',
          zoneId: 33656
        },
        {
          priceTypeId: 2,
          price: '190.0000',
          zoneId: 33657
        },
        {
          priceTypeId: 2,
          price: '180.0000',
          zoneId: 33678
        },
        {
          priceTypeId: 2,
          price: '170.0000',
          zoneId: 33659
        },
        {
          priceTypeId: 2,
          price: '160.0000',
          zoneId: 33660
        },
        {
          priceTypeId: 2,
          price: '150.0000',
          zoneId: 33661
        }
      ],
      zoneMapId: 61
    }
  ],
  photoPreviewsSeatIds: [7006],
  priceTypes: [
    {
      id: 1,
      order: 1
    },
    {
      id: 2,
      order: 2
    }
  ],
  type: 'PROVIDE_CONFIGURATION'
};
